import dayjs from 'dayjs';

const calculateAge = (birthDateStr, asOfDateStr) => {
  const birthDate = dayjs(birthDateStr || '');
  if (birthDate.isValid()) {
    let asOfDate = asOfDateStr ? dayjs(asOfDateStr) : dayjs();
    const today = dayjs();
    if (asOfDate.isBefore(today, 'day')) {
      asOfDate = today;
    }
    const birthYear = +birthDate.format('YYYY');
    const asOfYear = +asOfDate.format('YYYY');
    let travelerAge = asOfYear - birthYear;
    if (birthDate.diff(asOfDate.subtract(travelerAge, 'year').format('MM-DD-YYYY')) > 0) {
      travelerAge -= 1;
    }
    return travelerAge;
  }
  return null;
};

export default calculateAge;
